import React from 'react';
import { SurveyCreate } from './SurveyCreate';
import SurveyTableContainer from './SurveyTableContainer';

export function SurveyContainer() {
  return <SurveyTableContainer />;
}
